import { useEffect, useRef, useState } from "preact/hooks";

const RAW_CSS = `
.react-dat-gui {
  width: var(--ui-width);
  font-size: 12px;
  box-sizing: border-box;
  --type-color:white;
}
.react-dat-gui .dg {
  margin: 0;
  padding: 0;
  color: var(--type-color);
  overflow: hidden;
}
.react-dat-gui .dg ul {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
}
.react-dat-gui .dg.main {
  overflow-y: scroll;
}
.react-dat-gui .dg.main::-webkit-scrollbar {
  width: 5px;
  background: grey;
}
.react-dat-gui .dg.main::-webkit-scrollbar-corner {
  height: 0;
  display: none;
}
.react-dat-gui .dg.main::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: grey;
}
.react-dat-gui .cr {
  background-color: var(--background-color);
  border-left: var(--border-left-size) solid var(--type-color);
}
.react-dat-gui .cr:not(:last-child) {
  border-bottom: 1px solid var(--border-color);
}
.react-dat-gui .cr label {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 1px 2px 1px 8px;
  color: var(--type-color);
}
.react-dat-gui .cr label .label-text {
  color: white;
  width: 40%;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  color: var(--type-color);
}
.react-dat-gui .cr input {
  color: var(--type-color);
  background: var(--input-color);
  border: 3px solid var(--background-color);
  border-radius: 0;
  margin: 0;
  outline: none;
  font-size: inherit;
}
.react-dat-gui .cr input:hover {
  background: var(--input-color);
}
.react-dat-gui .cr input:focus {
  background: var(--input-color);
  color: #fff;
}
.react-dat-gui .cr input::-ms-clear {
  display: none;
}
.react-dat-gui li.folder {
  display: block;
  padding: 0;
}
.react-dat-gui li.folder .title {
  font-weight: bold;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  display: block;
  cursor: pointer;
  padding: 5px 5px 5px 16px;
  background: var(--folder-open);
  color: white;
  display: flex;
}
.react-dat-gui li.folder .title .text {
  flex-grow: 1;
}
.react-dat-gui li.folder .title .ctrl {
  display: flex;
  gap: 5px;
}
.react-dat-gui li.folder ul {
  border-left: var(--nest-margin) solid black;
  width: calc(100% - #{ var(--nest-margin) });
}
.react-dat-gui li.folder.closed .title {
  background: var(--folder-closed);
}
.react-dat-gui li.folder.closed ul {
  display: none;
}
.react-dat-gui .cr.boolean {
  --type-color:var(--boolean-color);
}
.react-dat-gui .cr.boolean label {
  cursor: pointer;
}
.react-dat-gui .cr.boolean .checkbox-container {
  width: 100%;
}
.react-dat-gui .cr.boolean input[type=checkbox] {
  margin: 0;
  vertical-align: middle;
}
.react-dat-gui .cr.button {
  --type-color:var(--button-color);
}
.react-dat-gui .cr.button:hover {
  background: #111;
}
.react-dat-gui .cr.button .label-text {
  display: block;
  width: 100%;
  cursor: pointer;
}
.react-dat-gui .cr.number {
  --type-color:var(--number-color);
}
.react-dat-gui .cr.number .slider {
  display: block;
  position: relative;
  border: 3px solid var(--background-color);
  border-right-width: 1px;
  background-color: var(--input-color);
  background-image:
    linear-gradient(
      90deg,
      var(--type-color),
      var(--type-color));
  background-size: 0% 100%;
  background-repeat: no-repeat;
  cursor: ew-resize;
  height: var(--number-height);
}
.react-dat-gui .cr.string {
  --type-color:var(--string-color);
}
.react-dat-gui .cr.select {
  --type-color:var(--select-color);
}
.react-dat-gui .cr.color {
  border-left: var(--border-left-size) solid var(--background-color);
}
.react-dat-gui .cr.color .swatch {
  text-align: center;
  font-weight: bold;
  color: white;
  text-shadow: rgba(0, 0, 0, 0.7) 0px 1px 1px;
  padding: var(--input-padding);
  border: var(--input-border);
  cursor: pointer;
}
.react-dat-gui .cr.color .popover {
  position: absolute;
  z-index: 2;
  right: 5px;
}
.react-dat-gui .cr.color .cover {
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
}
.react-dat-gui .cr.color .picker {
  background: #fff;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.3), 0 4px 8px rgba(0, 0, 0, 0.3);
  box-sizing: initial;
  width: auto;
  font-family: Menlo, sans-serif;
  margin-top: -3px;
}
.react-dat-gui .cr.color .picker .body {
  padding: 0px;
}
.react-dat-gui .cr.color .picker .body .controls {
  display: flex;
}
.react-dat-gui .cr.color .picker .body .controls .toggles {
  flex: 1;
}
.react-dat-gui .cr.color .picker .body .controls .toggles .hue-wrap {
  height: 10px;
  position: relative;
}
.react-dat-gui .cr.color .picker .saturation-wrap {
  width: 100%;
  padding-bottom: 55%;
  position: relative;
  overflow: hidden;
}
.react-dat-gui .cr.color .fields-wrap {
  display: flex;
}
.react-dat-gui .cr.color .fields-wrap .fields {
  flex: 1;
  display: flex;
  margin-left: -6px;
}
.react-dat-gui .cr.color .fields-wrap .fields .field {
  padding-left: 6px;
  width: 100%;
}
.react-dat-gui .cr.color .fields-wrap .fields .field input {
  font-size: 11px;
  color: #333;
  border-radius: 2px;
  border: none;
  box-shadow: inset 0 0 0 1px #dadada;
  height: 21px;
  text-align: center;
}
.react-dat-gui .cr.color .fields-wrap .fields .field input:focus {
  outline: none;
}
.react-dat-gui .cr.color .fields-wrap .fields .field label {
  text-transform: uppercase;
  font-size: 11px;
  line-height: 0;
  color: #969696;
  text-align: center;
  display: block;
  margin-top: 12px;
}
.react-dat-gui .cr.color .pointer {
  width: 12px;
  height: 12px;
  border-radius: 6px;
  transform: translate(-6px, -1px);
  background-color: rgb(248, 248, 248);
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.37);
  position: absolute;
  z-index: 3;
}
.react-dat-gui .cr.color .pointer-circle {
  width: 12px;
  height: 12px;
  border-radius: 6px;
  box-shadow: inset 0 0 0 1px #fff;
  transform: translate(-6px, -6px);
}
.react-dat-gui .cr.presets {
  --type-color:var(--presets-color);
}
.react-dat-gui .cr.presets label select {
  width: 100%;
}
`;

export function useHeaderStyle(id: string) {
  const [elem, setElem] = useState(document.getElementById(id));
  useEffect(() => {
    const existing = document.getElementById(id);
    if (existing) {
      setElem(existing);
    } else {
      const newElem = document.createElement("style");
      newElem.id = id;
      document.head.appendChild(newElem);
      setElem(newElem);
    }

    return () => {};
  }, [id]);
  return elem;
}

export function useDatStyle() {
  const elem = useHeaderStyle("dat-stylesheet");
  useEffect(() => {
    if (elem) {
      elem.textContent = RAW_CSS;
    }
  }, [elem]);
}
